import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21d274b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_2 = { class: "dialog-footer" }

import BaseEchart from '@/components/BaseEchart.vue';
import { ref, onMounted, watch } from 'vue';
import dayjs from "dayjs";
import { getListData } from "@/service/main/system";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailDialog',
  props: {
    visible: { type: Boolean },
    row: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const startDate = ref<string>(dayjs().subtract(7, 'days').format('YYYY-MM-DD'));
const endDate = ref<string>(dayjs().format('YYYY-MM-DD'));

const closeDialog = () => {
  emit('close');
};

const filteredData = ref([])

watch(() => props.visible, (newValue) => {
  if (newValue) {
    console.log(props.row);
    fetchFilteredData();
  }
});

const fetchFilteredData = () => {
  getListData('/main/preCommPlan/statisticDay', {
    startDate: startDate.value,
    endDate: endDate.value,
    empName: props.row.employeeName
  }).then(res => {
    filteredData.value = res;
    updateChart(filteredData.value);
  });
};

const options = ref<echarts.EChartsOption | null>(null);

const exportExcel = () => {
    /* generate workbook object from table */
    var xlsxParam = { raw: true } // 导出的内容只做解析，不进行格式转换
    var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)

    /* get binary string as output */
    var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
    try {
      FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
    } catch (e) {
      if (typeof console !== 'undefined') {
        console.log(e, wbout)
      }
    }
    return wbout
}

const updateChart = (data: any[]) => {
  const dates = data.map(d => d.dateStr);
  const activePlans = data.map(d => d.activePlans);
  const followUpRecords = data.map(d => d.followUpRecords);
  const followUpPlans = data.map(d => d.followUpPlans);
  const managerSuggestions = data.map(d => d.managerSuggestions);
  const managerSuggestionPlans = data.map(d => d.managerSuggestionPlans);
  const aiSuggestions = data.map(d => d.aiSuggestions);

  options.value = {
    title: {
      text: '沟通计划跟踪情况'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['进行中计划数', '跟踪记录数', '跟踪计划数', '经理建议数', '经理建议计划数', 'AI建议数']
    },
    toolbox: {
      feature: {
        dataView: {
          show: true,
          readOnly: false,
          title: '数据视图',
          lang: ['数据视图', '关闭', '导出excel'],
          contentToOption(opt) {
            exportExcel()
          },
          optionToContent: function (opt: any) {
            let axisData = opt.xAxis[0].data; //坐标数据
            let series = opt.series; //折线图数据
            let tdHeads = '<td  style="padding: 0 10px;font-weight: bold;background-color: cornsilk">时间</td>'; //表头
            let tdBodys = ''; //数据
            series.forEach(function (item: any) {
              //组装表头
              tdHeads += `<td style="padding: 0 10px;font-weight: bold;background-color: cornsilk">${item.name}</td>`;
            });
            let table = `<table id="exportTab" border="1" style="margin:auto;border-collapse:collapse;font-size:14px;text-align:center"><tbody><tr>${tdHeads} </tr>`;
            for (let i = 0, l = axisData.length; i < l; i++) {
              for (let j = 0; j < series.length; j++) {
                //组装表数据
                tdBodys += `<td>${ series[j].data[i]}</td>`;
              }
              table += `<tr><td style="padding: 0 10px;font-weight: bold;background-color: cornsilk">${axisData[i]}</td>${tdBodys}</tr>`;
              tdBodys = '';
            }
            table += '</tbody></table>';
            return table;
          }
        },
        saveAsImage: { show: true }
      }
    },
    xAxis: {
      type: 'category',
      data: dates
    },
    yAxis: {
      type: 'value'
    },
    series: [
      // {
      //   name: '沟通计划数',
      //   type: 'line',
      //   data: communicationPlans
      // },
      {
        name: '进行中计划数',
        type: 'line',
        data: activePlans
      },
      // {
      //   name: '成交计划数',
      //   type: 'line',
      //   data: endPlans
      // },
      {
        name: '跟踪记录数',
        type: 'line',
        data: followUpRecords
      },
      {
        name: '跟踪计划数',
        type: 'line',
        data: followUpPlans
      },
      {
        name: '经理建议数',
        type: 'line',
        data: managerSuggestions
      },
      {
        name: '经理建议计划数',
        type: 'line',
        data: managerSuggestionPlans
      },
      {
        name: 'AI建议数',
        type: 'line',
        data: aiSuggestions
      }
    ]
  };
};


return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "详情",
    modelValue: props.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((props.visible) = $event)),
    width: "60%",
    "max-width": "600px",
    onClose: closeDialog
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, { onClick: closeDialog }, {
          default: _withCtx(() => [
            _createTextVNode("关闭")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        inline: true,
        onSubmit: _withModifiers(fetchFilteredData, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "开始日期" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: startDate.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
                type: "date",
                placeholder: "选择开始日期",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "结束日期" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: endDate.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
                type: "date",
                placeholder: "选择结束日期",
                format: "YYYY-MM-DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                "native-type": "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("筛选")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        (options.value)
          ? (_openBlock(), _createBlock(BaseEchart, {
              key: 0,
              class: "exchangeChart",
              options: options.value,
              width: "1000px"
            }, null, 8, ["options"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})